export default {
	"home":"ホーム",
	"homeOne":"ホームワン",
	"homeTwo":"ホーム2",
	"homeThree":"ホームスリー",
	"userProfile":"ユーザープロフィール",
	"shop":"ショップ",
	"productDetails": "製品詳細",
	"cart": "カート",
	"checkout":"チェックアウト",
	"payment":"支払い",
	"fashion": "ファッション",
	"gadgets": "ガジェット",
	"accessories":"付属品",
	"categories":"カテゴリー",
	"men":"男性",
	"jean": "ジャン",
	"jackets":"ジャケット",
	"shirt":"シャツ",
	"tShirt":"Tシャツ",
	"women":"女性",
	"dress":"ドレス",
	"dresses":"ドレス",
	"headphone":"ヘッドホン",
	"smartphone":"スマートフォン",
	"watch":"時計",
	"speaker":"スピーカー",
	"laptopAccessories":"ノートパソコンのアクセサリ",
	"belts":"ベルト",
	"jewellery":"ジュエリー",
	"purse":"財布",
	"pages":"ページ",
	"about":"約",
	"termAndCondition":"取引条件",
	"privacyPolicy":"個人情報保護方針",
	"blogDetail":"ブログの詳細",
	"faq":"よくある質問",
	"Page":"ページ",
	"404Page":'404ページ',
	"session":"セッション",
	"signIn":"サインイン",
	"register":"登録",
	"forgotPassword":"パスワードをお忘れですか",
	"thankYou":"ありがとうございました",
	"contactUs":"お問い合わせ",
	"social":"ソーシャル",
	"facebook": "フェイスブック",
	"twitter":"Twitter",
	"youtube":"Youtube",
	"googlePlus":"グーグルプラス",
	"reports":"レポート",
	"invoices":"請求書",
	"profile":"プロフィール",
	"products":"製品情報",
	"productAdd":"製品追加",
	"goToSite":"サイトへ",
	"adminPanel":"管理パネル",
	"edit": "編集する"
}